/* 🤖 this file was generated by svg-to-ts */
export const matIconGavel: {
  name: 'gavel';
  data: string;
} = {
  name: 'gavel',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M1 21h12v2H1v-2zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L5.24 8.07zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66L12.32 1zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31l2.83-2.83z"/></svg>`
};
